export default {
  nav: {
    home: 'Inicio',
    about: 'Nosotros',
    services: 'Servicios',
    portfolio: 'Portafolio',
    contact: 'Contacto',
  },
  hero: {
    slides: {
      marketing: {
        title: 'Excelencia en Marketing Digital',
        description: 'Transforma tu negocio con estrategias de marketing basadas en datos que entregan resultados medibles y maximizan tu ROI',
        cta: 'Comienza a Crecer Hoy'
      },
      webdesign: {
        title: 'Diseño Web Profesional',
        description: 'Crea sitios web impresionantes y responsivos que cautivan a tu audiencia y convierten visitantes en clientes leales',
        cta: 'Obtén Tu Sitio Web'
      },
      socialmedia: {
        title: 'Marketing en Redes Sociales',
        description: 'Domina todas las plataformas sociales principales con contenido atractivo y campañas estratégicas que construyen la presencia de tu marca',
        cta: 'Impulsa Tu Presencia'
      },
      googleads: {
        title: 'Partner de Google Ads',
        description: 'Partner certificado de Google entregando campañas publicitarias de alto rendimiento que alcanzan a tu audiencia objetivo en el momento perfecto',
        cta: 'Lanza Tu Campaña'
      },
      facebookads: {
        title: 'Experto en Facebook Ads',
        description: 'Partner de Meta Business creando poderosas campañas publicitarias en Facebook e Instagram que impulsan el engagement y las ventas',
        cta: 'Comienza a Anunciar'
      },
      consulting: {
        title: 'Consultoría Estratégica',
        description: 'Orientación experta en todas las plataformas sociales para optimizar tu estrategia digital y lograr un crecimiento sostenible',
        cta: 'Obtén Asesoría Experta'
      }
    },
    learnMore: 'Conoce Más',
  },
  about: {
    title: 'Acerca de Axloweb',
    subtitle: 'Tu Socio en Éxito Digital',
    description: 'Somos una agencia líder de marketing digital en Santa Rosa, California, especializada en soluciones integrales en línea. Con certificaciones como Google Partner y Facebook Business Partner, entregamos resultados excepcionales para empresas de todos los tamaños.',
    mission: 'Empoderar a las empresas con estrategias innovadoras de marketing digital que impulsan el crecimiento, aumentan la visibilidad y maximizan el ROI a través de tecnología de vanguardia y excelencia creativa.',
    vision: 'Ser el socio de marketing digital más confiable en el norte de California, reconocido por transformar negocios a través de estrategias basadas en datos y un servicio excepcional al cliente.',
    values: 'Excelencia en cada proyecto, transparencia y honestidad, innovación y creatividad, éxito del cliente primero, y mejora continua.',
  },
  services: {
    title: 'Nuestros Servicios',
    subtitle: 'Soluciones Digitales Integrales Adaptadas a las Necesidades de Tu Negocio',
    marketing: {
      title: 'Marketing Digital',
      description: 'Estrategias completas de marketing digital incluyendo SEO, marketing de contenidos, campañas de email y analítica para hacer crecer tu presencia en línea.',
      features: {
        0: 'Optimización SEO',
        1: 'Marketing de Contenidos',
        2: 'Campañas de Email',
        3: 'Analítica e Informes'
      }
    },
    webDesign: {
      title: 'Diseño Web',
      description: 'Sitios web personalizados y responsivos construidos con tecnologías modernas que representan tu marca perfectamente y convierten visitantes.',
      features: {
        0: 'Diseño Responsivo',
        1: 'UI/UX Moderno',
        2: 'Carga Rápida',
        3: 'Optimizado para Móviles'
      }
    },
    socialMedia: {
      title: 'Marketing en Redes Sociales',
      description: 'Gestión estratégica de redes sociales en todas las plataformas principales para involucrar a tu audiencia y construir presencia de marca.',
      features: {
        0: 'Creación de Contenido',
        1: 'Gestión de Comunidad',
        2: 'Marketing de Influencers',
        3: 'Analítica Social'
      }
    },
    googleAds: {
      title: 'Google Ads',
      description: 'Partner certificado de Google creando campañas publicitarias de alto rendimiento que maximizan el ROI y alcanzan a tu audiencia objetivo.',
      features: {
        0: 'Anuncios de Búsqueda',
        1: 'Anuncios Display',
        2: 'Anuncios Shopping',
        3: 'Anuncios de Video'
      }
    },
    facebookAds: {
      title: 'Facebook Ads',
      description: 'Partner de Meta Business entregando poderosas campañas publicitarias en Facebook e Instagram que impulsan resultados.',
      features: {
        0: 'Anuncios Facebook',
        1: 'Anuncios Instagram',
        2: 'Segmentación de Audiencia',
        3: 'Seguimiento de Conversiones'
      }
    },
    consulting: {
      title: 'Consultoría',
      description: 'Servicios de consultoría profesional para todas las plataformas de redes sociales con información accionable para mejorar tu presencia digital.',
      features: {
        0: 'Planificación Estratégica',
        1: 'Análisis de Plataformas',
        2: 'Auditoría de Rendimiento',
        3: 'Hoja de Ruta de Crecimiento'
      }
    }
  },
  portfolio: {
    title: 'Nuestro Portafolio',
    subtitle: 'Explora Nuestras Historias de Éxito y Proyectos Recientes',
    viewProject: 'Ver Proyecto',
    projects: {
      fotosyvideo: {
        title: 'Fotos y Video Santa Rosa',
        description: 'Sitio web de servicios profesionales de fotografía y videografía con impresionantes galerías de portafolio y sistema de reservas en línea.'
      },
      imagenprinting: {
        title: 'Imagen Printing',
        description: 'Plataforma completa de servicios de impresión con catálogos de productos, formularios de pedidos personalizados y calculadora de cotizaciones instantáneas.'
      },
      latinoofertasqr: {
        title: 'Latino Ofertas QR',
        description: 'Plataforma innovadora de ofertas basada en códigos QR que conecta negocios locales con la comunidad latina a través de cupones digitales.'
      },
      latinoofertasmarket: {
        title: 'Latino Ofertas Market',
        description: 'Mercado en línea con ofertas exclusivas y promociones para la comunidad latina con carrito de compras integrado.'
      },
      latinoofertasmagazine: {
        title: 'Latino Ofertas Magazine',
        description: 'Plataforma de revista digital que muestra noticias de la comunidad, perfiles de negocios y ofertas especiales con contenido atractivo.'
      },
      kaespinoza: {
        title: 'K&A Espinoza Concrete',
        description: 'Sitio web de servicios profesionales de concreto con galerías de proyectos, descripciones de servicios y formularios de solicitud de cotización instantánea.'
      },
      storkmovers: {
        title: 'Stork Movers LLC',
        description: 'Sitio web de servicios de mudanza profesional con cotizaciones instantáneas, cobertura de área de servicio y testimonios de clientes.'
      },
      luisramosea: {
        title: 'Luis Ramos EA',
        description: 'Sitio web de especialista en alivio de impuestos y representación ante el IRS, ayudando a clientes a resolver problemas fiscales con servicios de consultoría profesional.'
      }
    }
  },
  contact: {
    title: 'Contáctanos',
    subtitle: 'Comencemos Juntos Tu Viaje de Transformación Digital',
    form: {
      name: 'Nombre Completo',
      email: 'Correo Electrónico',
      phone: 'Número de Teléfono',
      company: 'Nombre de la Empresa',
      service: 'Servicio de Interés',
      message: 'Tu Mensaje',
      submit: 'Enviar Mensaje',
      sending: 'Enviando...',
      success: '¡Mensaje enviado exitosamente! Te contactaremos pronto.',
      error: 'Error al enviar mensaje. Por favor intenta de nuevo.'
    },
    info: {
      phone: 'Teléfono',
      email: 'Correo',
      address: 'Dirección',
      hours: 'Horario de Atención',
      hoursValue: 'Lunes - Viernes: 9:00 AM - 6:00 PM'
    }
  },
  footer: {
    description: 'Agencia profesional de marketing digital en Santa Rosa, California. Partner de Google y Partner de Facebook Business entregando resultados excepcionales.',
    quickLinks: 'Enlaces Rápidos',
    services: 'Servicios',
    followUs: 'Síguenos',
    copyright: '© 2024 Axloweb. Todos los derechos reservados.',
    poweredBy: 'Desarrollado por Readdy'
  }
};
